import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import Home from "./components/Home/Home";
import About from "./components/About/About";
import HealthcareLIMS from "./components/HealthcareLIMS/HealthcareLIMS";
import QualityManagement from "./components/QualityManagement/QualityManagement";
import InventoryManagement from "./components/InventoryManagement/InventoryManagement";
import VeterinaryLIMS from "./components/VerterinaryLIMS/VeterinaryLIMS";
import WhyChooseUs from "./components/WhyChooseus/WhyChooseus";
import Clients from "./components/Clients/Clients";
import Contact from "./components/Contact/ContactPage";

import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/header/Header";
import Footer from "./components/Footer";
import ScrollDownButton from "./components/ScrollDownButton";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <ScrollDownButton />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products/healthcare/" element={<HealthcareLIMS />} />
        <Route path="/products/quality-management-system/" element={<QualityManagement />} />
        <Route path="/products/inventory/" element={<InventoryManagement />} />
        <Route path="/products/veterinary/" element={<VeterinaryLIMS />} />
        <Route path="/why-choose-us/" element={<WhyChooseUs />} />
        <Route path="/clients/" element={<Clients />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;